import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { FlareFileReviewerToolbarContentModule } from '@portal-core/reviews/components/flare-file-reviewer-toolbar-content/flare-file-reviewer-toolbar-content.module';
import { FlareFileReviewerModule } from '@portal-core/reviews/components/flare-file-reviewer/flare-file-reviewer.module';
import { ReviewFileAvatarModule } from '@portal-core/reviews/review-files/components/review-file-avatar/review-file-avatar.module';
import { ReviewPackageAvatarModule } from '@portal-core/reviews/review-packages/components/review-package-avatar/review-package-avatar.module';
import { ReviewPackageAsyncModule } from '@portal-core/reviews/review-packages/pipes/review-package-async/review-package-async.module';
import { ReviewEditSnippetDialogComponent } from './review-edit-snippet-dialog.component';

@NgModule({
  declarations: [
    ReviewEditSnippetDialogComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    FlareFileReviewerModule,
    FlareFileReviewerToolbarContentModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    MatDividerModule,
    ProjectAsyncModule,
    ProjectAvatarModule,
    ReviewFileAvatarModule,
    ReviewPackageAsyncModule,
    ReviewPackageAvatarModule,
    SelfTruncatingPathModule
  ],
  exports: [
    ReviewEditSnippetDialogComponent
  ]
})
export class ReviewEditSnippetDialogModule { }
